module.exports = __webpack_public_path__ + "img/1563499540.0ecd803c.jpg";